module.exports = __webpack_public_path__ + "img/sb.a8ed04c0.png";